function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.76173 17.7635H7.95338H14.0622L15.9307 21.5511H21.7041V0.119629H0V21.671H5.86921L7.76173 17.7635Z",
  fill: "#FBB040"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7041 22.606H0V27.9998H21.7041V22.606Z",
  fill: "#807F83"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7251 27.7124L40.3897 26.7055H38.3535L38.0181 27.7124H36.8442L38.9284 21.9829H39.8148L41.8989 27.7124H40.7251ZM39.3836 23.685L38.6649 25.7706H40.0783L39.3836 23.685Z",
  fill: "#807F83"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.0919 27.7124V21.9829H51.2178V26.7055H53.8051V27.7124H50.0919Z",
  fill: "#807F83"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6688 27.7124V21.9829H63.7948V26.7055H66.382V27.7124H62.6688Z",
  fill: "#807F83"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M76.5632 27.7124V21.9829H77.6892V27.7124H76.5632Z",
  fill: "#807F83"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M91.0566 27.7124L90.7213 26.7055H88.685L88.3496 27.7124H87.1758L89.2599 21.9829H90.1463L92.2305 27.7124H91.0566ZM89.7391 23.685L89.0204 25.7706H90.4338L89.7391 23.685Z",
  fill: "#807F83"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M103.49 27.7124L101.214 24.1884V27.7124H100.088V21.9829H101.094L103.37 25.4829V21.9829H104.496V27.7124H103.49Z",
  fill: "#807F83"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M114.869 27.7603C114.246 27.7603 113.743 27.5446 113.336 27.137C113.096 26.8973 112.928 26.6096 112.88 26.274C112.809 25.9624 112.785 25.4829 112.785 24.8596C112.785 24.2364 112.809 23.7569 112.88 23.4453C112.952 23.1097 113.096 22.846 113.336 22.5823C113.743 22.1747 114.27 21.959 114.869 21.959C115.971 21.959 116.785 22.6062 116.977 23.7809H115.851C115.731 23.3015 115.42 22.9658 114.893 22.9658C114.581 22.9658 114.342 23.0617 114.174 23.2535C113.935 23.4932 113.887 23.7569 113.887 24.8596C113.887 25.9624 113.935 26.2261 114.174 26.4658C114.342 26.6576 114.581 26.7535 114.893 26.7535C115.42 26.7535 115.731 26.4418 115.851 25.9384H116.977C116.785 27.1131 115.971 27.7603 114.869 27.7603Z",
  fill: "#807F83"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M125.577 27.7124V21.9829H129.338V22.9898H126.679V24.3322H128.931V25.3391H126.679V26.7295H129.338V27.7363L125.577 27.7124Z",
  fill: "#807F83"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6581 18.363V10.6678H27.4535V18.363H23.8601V0H27.4535V7.50342H33.6581V0H37.2515V18.363H33.6581Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M59.0994 18.3632L56.2726 12.5858H54.2364V18.3632H51.4095V3.88379H57.0871C60.0337 3.88379 61.7825 5.89749 61.7825 8.31872C61.7825 10.3564 60.5368 11.6029 59.1473 12.1303L62.3814 18.3632H59.0994ZM56.8955 6.40091H54.2364V10.2125H56.8955C58.1412 10.2125 58.9557 9.42144 58.9557 8.29472C58.9557 7.19198 58.1412 6.40091 56.8955 6.40091Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2334 16.9728C72.2752 17.9317 70.9097 18.3632 69.4244 18.3632H64.202V3.88379H69.4244C70.9337 3.88379 72.2991 4.3153 73.2334 5.2742C74.8624 6.90434 74.6947 8.89406 74.6947 11.0756C74.7187 13.2331 74.8624 15.3667 73.2334 16.9728ZM71.269 7.31187C70.7899 6.71256 70.1192 6.42486 69.1609 6.42486H67.0288V15.8701H69.1609C70.1431 15.8701 70.7899 15.5584 71.269 14.9831C71.7961 14.3358 71.8679 13.305 71.8679 11.0995C71.8919 8.87007 71.7961 7.95913 71.269 7.31187Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M89.0922 18.3631L88.2298 15.798H81.4503L80.5879 18.3631H77.6173L83.2949 0.191895H86.3373L92.0388 18.3631H89.0922ZM84.876 4.45901L82.2408 13.4248H87.4872L84.876 4.45901Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M113.432 18.3632V3.88379H122.151V6.40091H116.258V9.80502H121.145V12.3221H116.258V15.8461H122.151V18.3632H113.432Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M134.297 3.88379H123.541V6.40091H127.326V18.3632H130.153V6.40091H132.764C133.027 5.41804 133.554 4.57899 134.297 3.88379Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M138.657 18.4828C136.453 18.4828 134.8 18.0273 133.363 16.565L135.184 14.7431C136.094 15.6541 137.34 15.9657 138.681 15.9657C140.358 15.9657 141.244 15.3424 141.244 14.1678C141.244 13.6643 141.101 13.2329 140.789 12.9452C140.502 12.6815 140.19 12.5376 139.52 12.4418L137.771 12.202C136.525 12.0102 135.615 11.6267 134.968 11.0034C134.273 10.3082 133.938 9.37326 133.938 8.15066C133.938 5.56162 135.854 3.76367 138.969 3.76367C140.957 3.76367 142.394 4.24312 143.64 5.44175L141.843 7.21573C140.933 6.35271 139.831 6.20888 138.873 6.20888C137.364 6.20888 136.645 7.04792 136.645 8.0308C136.645 8.39038 136.765 8.77392 137.076 9.06159C137.364 9.32529 137.819 9.54107 138.418 9.63696L140.118 9.87669C141.436 10.0685 142.275 10.4281 142.873 11.0034C143.64 11.7465 143.999 12.8013 143.999 14.0719C144.023 16.9007 141.676 18.4828 138.657 18.4828Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M110.772 11.0273C110.173 10.452 109.335 10.0924 108.017 9.90061L106.317 9.66089C105.718 9.58897 105.262 9.34927 104.975 9.08557C104.664 8.7979 104.544 8.41431 104.544 8.05472C104.544 7.04787 105.286 6.2328 106.772 6.2328C107.73 6.2328 108.832 6.35267 109.742 7.23965L111.539 5.46568C110.293 4.26705 108.856 3.7876 106.868 3.7876C103.729 3.7876 101.837 5.60952 101.837 8.17458C101.837 9.39719 102.172 10.3321 102.867 11.0273C103.514 11.6506 104.424 12.0342 105.67 12.226L107.419 12.4657C108.089 12.5616 108.425 12.7054 108.688 12.9691C109 13.2568 109.143 13.6883 109.143 14.1917C109.143 15.3424 108.257 15.9897 106.58 15.9897C105.239 15.9897 103.993 15.678 103.083 14.767C102.987 15.726 102.651 16.589 102.148 17.3321C103.37 18.1952 104.783 18.5068 106.532 18.5068C109.551 18.5068 111.898 16.9246 111.898 14.1198C111.898 12.8253 111.539 11.7465 110.772 11.0273Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M100.352 11.0273C99.7527 10.452 98.9142 10.0924 97.5967 9.90061L95.8958 9.66089C95.2969 9.58897 94.8417 9.34927 94.5542 9.08557C94.2428 8.7979 94.123 8.41431 94.123 8.05472C94.123 7.04787 94.8657 6.2328 96.3509 6.2328C97.3092 6.2328 98.4112 6.35267 99.3215 7.23965L101.118 5.46568C99.8725 4.26705 98.4351 3.7876 96.4468 3.7876C93.3085 3.7876 91.416 5.60952 91.416 8.17458C91.416 9.39719 91.7514 10.3321 92.4461 11.0273C93.0929 11.6506 94.0033 12.0342 95.249 12.226L96.9978 12.4657C97.6685 12.5616 98.0039 12.7054 98.2674 12.9691C98.5788 13.2568 98.7226 13.6883 98.7226 14.1917C98.7226 15.3424 97.8362 15.9897 96.1593 15.9897C94.8178 15.9897 93.5721 15.678 92.6617 14.767L92.6138 14.815L93.7158 17.8116L93.8835 18.2671C94.5782 18.4109 95.2969 18.4828 96.1114 18.4828C99.1298 18.4828 101.478 16.9006 101.478 14.0958C101.454 12.8253 101.118 11.7465 100.352 11.0273Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M44.8456 3.88379H42.6416L38.9285 14.0961V18.3632H40.3179L41.1803 15.7982H46.3309L47.1933 18.3632H50.1399L44.8456 3.88379ZM41.9948 13.4249L43.8155 8.15091L45.5882 13.4249H41.9948Z",
  fill: "black"
});

var SvgLogoColored = function SvgLogoColored(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 144 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoColored, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-colored.430cde48.svg";
export { ForwardRef as ReactComponent };